import { useTranslation } from "react-i18next";
import { ActionsType } from "@/components/custom/data-table/buttons/data-table-actions";
import { PiCubeFocus, PiTagChevron, PiUpload } from "react-icons/pi";
import {
  DeployModelAction,
  TagsActions,
  UploadConfigAction,
} from "./-clusters-actions-components";
import { usePermissions } from "@/hooks/use-permissions";

export const useActions = (): ActionsType => {
  const { t } = useTranslation();
  const { permissions } = usePermissions();

  return [
    {
      label: t("deployModel"),
      title: t("deployModelToClusters"),
      actionContent: DeployModelAction,
      icon: PiCubeFocus,
      dialogClassName: "!w-[1000px] !max-w-[90vw]",
      disabled: false,
    },
    // Gated like the route (PATCH /clusters/tagsBulk is clusters.tags.update -- ID-7148).
    permissions.clusters.tags.update && {
      label: t("tag"),
      title: t("editTags"),
      actionContent: TagsActions,
      icon: PiTagChevron,
    },
    {
      label: t("uploadConfig"),
      title: t("uploadConfigToClusters"),
      actionContent: UploadConfigAction,
      icon: PiUpload,
    },
  ].filter(Boolean) as ActionsType;
};
